export default class ConfirmationDirective {
    constructor(ModalService) {
        this.ModalService = ModalService;
        this.restrict = 'A';
        this.priority = 1;
        this.terminal = true;
    }

    link(scope, element, attrs) {

        const modalClosedCallback = (accept) => {
            if (accept === true) {
                element[0].form.submit();
            }
        };
        const message = attrs.confirmationMessage || 'Czy jesteś pewny/a?';

        const modalConfirmation = (e) => {
            e.preventDefault();

            this.ModalService.showModal({
                template: '\
                    <div class="modal" tabindex="-1" role="dialog">\
                        <div class="modal-dialog" role="document">\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <button type="button" class="close" ng-click="$ctrl.close(false)" aria-label="{{ \'configuratorManual.returnToCustomQuery\' | t }}" ng-disabled="$ctrl.loading"><span aria-hidden="true">&times;</span></button>\
                                    <h4 class="modal-title">{{ \'confirm.title\' | t }}</h4>\
                                </div>\
                                <div class="modal-body">\
                                    {{ $ctrl.message }}\
                                </div>\
                                <div class="modal-footer">\
                                    <div class="row">\
                                        <div class="col-xs-6 text-left">\
                                            <button type="button" class="btn btn-default" ng-click="$ctrl.close(false)">{{ \'confirm.no\' | t }}</button>\
                                        </div>\
                                        <div class="col-xs-6">\
                                            <button type="button" class="btn btn-default" ng-click="$ctrl.close(true)">{{ \'confirm.yes\' | t }}</button>\
                                        </div>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                    </div>',
                controller: class {
                    constructor($scope, close) {
                        'ngInject';
                        this.closeCallback = close;
                        this.message = message;
                    }

                    close(data) {
                        this.closeCallback(data);
                    }

                    confirm() {
                        this.close(true);
                        e.form.submit();
                    }
                },
                controllerAs: '$ctrl',
                preClose: (modal) => {
                    // Hide bootstrap modal
                    modal.element.modal('hide');
                }
            }).then(modal => {
                // Show bootstrap modal
                modal.element.modal({
                    backdrop: 'static',
                    keyboard: false
                });
                modal.closed.then(modalClosedCallback);
            });
        }

        element.bind('click', modalConfirmation);
    }

    static directiveFactory(ModalService) {
        'ngInject';

        return new ConfirmationDirective(ModalService);
    }
}
